export default __webpack_public_path__ + "static/media/testing.3300d5bf.jpg";